import React from "react";
import {
  ListNumberedOutlined,
  DashboardOutlined,
  TickCircleOpenOutlined,
  NoteOutlined,
  AssessmentApplicableOutlined,
  AssessmentandEvaluationOutlined,
  TextOutlined,
  QuestionMarkBlankOutlined,
  SettingsOutlined,
  CommentTextOutlined,
  ChecklistOutlined,
  JournalOutlined,
  TeacherResourceOutlined,
  WorkbookOutlined,
  MoveOutlined,
  StarsTwoFilled,
  GoalsOutlined,
  TableOutlined,
  PinOutlined,
  TickCrossOutlined,
  JournalFilled,
  ReplaceOutlined,
  TagOutlined,
  FolderFilled,
  AddOutlined,
  VideoOutlined,
  MicrophoneOutlined,
  BooksTwoOutlined,
} from "@toddle-edu/ds-icons";
import {
  fontStyles,
  colors,
  NoWorkbookTemplatesIllustration,
  ResourcesIllustration,
  DocumentAIIllustration,
} from "@toddle-edu/ds-theme";
import {
  CURRICULUM_TYPE_MYP,
  MYP_INTERDISCIPLINARY_CRITERIA_RUBRIC,
  MYP_OBJECTIVE_RUBRIC,
  CURRICULUM_TYPE_DP,
} from "Constants/stringConstants";

export const ASSESSMENT_TYPE_WORKSHEET = "worksheet";
export const TASK_TYPE_WORKSHEET = "WORKSHEET";

export const ORG_RESOURCE_TYPE_WORKSHEET = "WORKSHEET_RESOURCE";
export const RESOURCE_TYPE_FOLDER = "FOLDER";
export const RESOURCE_TYPE_QUESTION = "QUESTION";

export const QUESTION_SUBMISSION = "QUESTION_SUBMISSION";
export const GRADE_11 = "Grade 11";
export const GRADE_12 = "Grade 12";
export const GRADE_11_and_12 = "Grade 11 & 12";

// mode ->
//    teacher_create   -> teacher's view while in questions step of creating/editing a worksheet assessment
//    teacher_evaluate -> teacher's view while evaluating student's submissions
//    teacher_view     -> teacher's view after evaluating student's submissions
//    assessment_view  -> teacher's view mode of a worksheet assessment
//    restricted_assessment_view  -> teacher's view mode of a worksheet assessment without answers
//    teacher_preview  -> teacher's view of the student's submission view
//    student_attempt  -> student's view while attempting worksheet assessment
//    student_evaluate -> student's view while viewing worksheet assessment after teacher has evaluated
//    student_view     -> student's view while viewing worksheet assessment after submitting it
//    evaluation_insight  ->  teacher's view when in evaluation insights
export const MODE_TEACHER_CREATE = "teacher_create";
export const MODE_TEACHER_EVALUATE = "teacher_evaluate";
export const MODE_TEACHER_VIEW = "teacher_view";
export const MODE_ASSESSMENT_VIEW = "assessment_view";
export const MODE_RESTRICTED_ASSESSMENT_VIEW = "restricted_assessment_view";
export const MODE_TEACHER_PREVIEW = "teacher_preview";
export const MODE_STUDENT_ATTEMPT = "student_attempt";
export const MODE_STUDENT_EVALUATE = "student_evaluate";
export const MODE_STUDENT_VIEW = "student_view";
export const MODE_LIBRARY_VIEW = "library_view";
export const MODE_EVALUATION_INSIGHT = "evaluation_insight";

export const AUDIO_INSTRUCTIONS = "AUDIO_INSTRUCTIONS";
export const RESOURCES = "RESOURCES";
export const FINAL_REMARKS = "FINAL_REMARKS";
export const OVERALL_ASSESSMENT_TOOL = "OVERALL_ASSESSMENT_TOOL";
export const INDIVIDUAL_ASSESSMENT_TOOL = "INDIVIDUAL_ASSESSMENT_TOOL";
export const ASSESSMENT_CRITERIA = "ASSESSMENT_CRITERIA";
export const ANSWER_TEXT = "ANSWER_TEXT";
export const TEACHER_NOTES = "TEACHER_NOTES";
export const TEXT_RESPONSE = "TEXT_RESPONSE";
export const SHORT_RESPONSE = "SHORT_RESPONSE";
export const LONG_RESPONSE = "LONG_RESPONSE";
export const PRINT_DOTTED_LINES = "PRINT_DOTTED_LINES";

export const WORKSHEET_MODES = [
  MODE_TEACHER_CREATE,
  MODE_TEACHER_EVALUATE,
  MODE_TEACHER_VIEW,
  MODE_TEACHER_PREVIEW,
  MODE_STUDENT_ATTEMPT,
  MODE_STUDENT_EVALUATE,
  MODE_STUDENT_VIEW,
  MODE_ASSESSMENT_VIEW,
  MODE_RESTRICTED_ASSESSMENT_VIEW,
  MODE_LIBRARY_VIEW,
  MODE_EVALUATION_INSIGHT,
];

export const STUDENT_WORKSHEET_MODES = [
  MODE_STUDENT_ATTEMPT,
  MODE_STUDENT_VIEW,
  MODE_STUDENT_EVALUATE,
  MODE_TEACHER_PREVIEW,
];

export const QUESTION_UID_MULTI_PART = "multi_part_v2";
export const QUESTION_UID_TRUE_FALSE_V2 = "true_false_v2";
export const QUESTION_UID_TEXT_RESPONSE_V3 = "text_response_v3";
export const QUESTION_UID_BLANKS = "fill_the_blanks_v2";
export const QUESTION_UID_MULTI_CHOICE = "multi_choice_v2";
export const QUESTION_UID_GRAPHING = "geogebra_graphing";
export const QUESTION_UID_DRAWING = "workbook_drawing";
export const QUESTION_UID_DRAG_AND_DROP = "drag_and_drop";
export const QUESTION_UID_FIND_HOTSPOT = "find_hotspot";
export const QUESTION_UID_MATCHING = "matching";
export const QUESTION_UID_TABLE = "table";
export const QUESTION_UID_LABELLING = "labelling";

export const CONTENT_UID_TEXT_BOX = "text_box";

export const QUESTION_UID_SEPARATOR = "separator";
export const QUESTION_UID_VIDEO = "video";
export const QUESTION_UID_AUDIO = "audio";
export const QUESTION_UID_SECTION = "section";

export const ADD_QUESTION_FROM_LIBRARY = "add_from_library";
export const GENERATE_USING_AI = "generate_using_ai";
export const EXTRACT_FROM_DOC = "extract_from_doc/forms";

export const FIELD_UID_RICH_TEXT_EDITOR = "rich_text_editor";
export const FIELD_UID_ANSWER = "answer";
export const FIELD_UID_TEACHER_NOTES = "teacher_notes";
export const FIELD_UID_ASSESSMENT_TOOL = "measureAssessing";
export const FIELD_UID_SCORE = "score";
export const FIELD_UID_VOICE_INSTRUCTIONS = "voiceInstruction";
export const FIELD_UID_RESOURCES = "resources";
export const FIELD_UID_RESPONSE = "response";
export const FIELD_UID_TITLE = "title";
export const FIELD_UID_BLANKS = "blanks";
export const FIELD_UID_RADIO = "radio";
export const FIELD_UID_GRAPH_TEMPLATE = "graphTemplate";
export const FIELD_UID_BLANKS_ANSWERS = "blanksAnswers";
export const FIELD_UID_BLANKS_RESPONSES = "blanksResponses";
export const FIELD_UID_SETTINGS = "settings";
export const FIELD_TYPE_RICHTEXT_PORTED = "RichText_Ported";
export const FIELD_UID_MCQ_CHOICES = "choices";
export const FIELD_UID_MCQ_ANSWERS = "answers";

export const FIELD_UID_MCQ_RESPONSE = "mcqResponses";
export const FIELD_UID_GRAPH_RESPONSE = "graphResponse";
export const FIELD_UID_WORKBOOK_TEMPLATE = "workbookTemplate";
export const FIELD_UID_WORKBOOK_RESPONSE = "workbookResponse";
export const FIELD_UID_DRAG_AND_DROP = "dragAndDrop";
export const FIELD_UID_DRAG_AND_DROP_RESPONSE = "dragAndDropResponse";
export const FIELD_UID_DRAG_AND_DROP_ANSWERS = "dragAndDropAnswers";
export const FIELD_UID_FIND_HOTSPOT = "findHotspot";
export const FIELD_UID_FIND_HOTSPOT_RESPONSE = "findHotspotResponse";
export const FIELD_UID_FIND_HOTSPOT_ANSWERS = "findHotspotAnswers";
export const FIELD_UID_MATCHING = "matchingPairs";
export const FIELD_UID_MATCHING_RESPONSE = "matchingResponse";
export const FIELD_UID_MATCHING_ANSWERS = "matchingPairsAnswers";
export const FIELD_UID_ADD_LEARNING_GOALS = "addLearningGoals";
export const FIELD_UID_TABLE = "table";
export const FIELD_UID_TABLE_ANSWERS = "tableAnswers";

export const FIELD_UID_LABELLING = "labellingTool";
export const FIELD_UID_LABELLING_RESPONSE = "labellingResponse";
export const FIELD_UID_LABELLING_ANSWERS = "labellingAnswer";
export const FIELD_UID_DURATION = "duration";
export const FIELD_UID_AUDIO_RESPONSE = "audioResponse";
export const FIELD_UID_VIDEO_RESPONSE = "videoResponse";
export const FIELD_UID_SUBMISSION_METHOD = "submissionMethod";

export const QUESTION_TYPE_FILL_IN_THE_BLANKS = "Fill in the blanks";
export const QUESTION_TYPE_MULTIPLE_CHOICE = "Multiple choice";
export const QUESTION_TYPE_TRUE_OR_FALSE = "True or false";
export const QUESTION_TYPE_TEXT_RESPONSE = "Text response";
export const QUESTION_TYPE_INLINE_TEXT = "Inline text";

export const METADATA_ADDED_TO_LIBRARY_KEY = "added_to_school_library";
export const FIELD_UID_GRAPH_INTERACTION_SETTING = "allow_graph_interaction";
export const FIELD_UID_GRAPH_ALGEBRA_INPUT_SETTING = "allow_algebra_input";
export const FIELD_UID_TEXT_RESPONSE_SETTING = "allow_media";
export const FIELD_UID_WORKBOOK_INTERACTION_SETTING =
  "allow_workbook_interaction";
export const FIELD_UID_WORKBOOK_MODIFICATION_SETTING =
  "allow_workbook_modification";
export const FIELD_UID_ADDITIONAL_FIELD_SETTING = "allow_additional_text_field";
export const FIELD_UID_FIND_HOTSPOT_VISIBLE_SETTING =
  "allow_hotspot_to_show_students";
export const FIELD_UID_FIND_HOTSPOT_ALLOW_MULTIPLE_SETTING =
  "allow_multiple_hotspot_selection";
export const FIELD_UID_ALLOW_MULTIPLE_SELECTION_SETTING =
  "allow_multiple_selection";

export const DYNAMIC_ANSWER_FIELDS = [
  FIELD_UID_ANSWER,
  FIELD_UID_TEACHER_NOTES,
];

export const UPDATE_DEBOUNCE_CALL_TIME = 300;
export const CREATE_THROTTLED_CALL_TIME = 1000;
export const QUESTION_IMPORT_LIMIT = 20;

export const CONTENT_TEXT_BOX_PERM = "FeatureFlag:WorksheetsV2TextBox";

export const ASSESSMENT_FIELD_UID_SUBJECTS = "subjects";

export const QUESTION_FEED_TYPE_SAVED = "SAVED";
export const QUESTION_FEED_TYPE_ALL_QUESTIONS = "ALL_QUESTIONS";

export const QUESTION_TAG_SUBJECT = "subject";
export const QUESTION_TAG_TOPIC = "topic";

export const UNTIMED = "untimed";
export const TIMED = "timed";
export const FIXED_TIMED = "fixed_timed";

export const UNRESTRICTED = "no-restriction";
export const BROWSER_LOCK = "browser-lock";
export const LOCKDOWN_BROWSER = "lockdown";

export const QUESTION_TYPES = [
  GENERATE_USING_AI,
  ADD_QUESTION_FROM_LIBRARY,
  EXTRACT_FROM_DOC,
  QUESTION_UID_TEXT_RESPONSE_V3,
  QUESTION_UID_MULTI_CHOICE,
  QUESTION_UID_TRUE_FALSE_V2,
  QUESTION_UID_BLANKS,
  QUESTION_UID_MULTI_PART,
  QUESTION_UID_GRAPHING,
  QUESTION_UID_DRAWING,
  QUESTION_UID_DRAG_AND_DROP,
  QUESTION_UID_FIND_HOTSPOT,
  QUESTION_UID_TABLE,
  QUESTION_UID_MATCHING,
  QUESTION_UID_LABELLING,
  QUESTION_UID_AUDIO,
  QUESTION_UID_VIDEO,
];

export const QUESTION_TYPES_V2 = [
  GENERATE_USING_AI,
  EXTRACT_FROM_DOC,
  ADD_QUESTION_FROM_LIBRARY,
  QUESTION_UID_TEXT_RESPONSE_V3,
  QUESTION_UID_MULTI_CHOICE,
  QUESTION_UID_BLANKS,
  QUESTION_UID_TRUE_FALSE_V2,
  QUESTION_UID_GRAPHING,
  QUESTION_UID_DRAWING,
  QUESTION_UID_TABLE,
  QUESTION_UID_MATCHING,
  QUESTION_UID_DRAG_AND_DROP,
  QUESTION_UID_FIND_HOTSPOT,
  QUESTION_UID_LABELLING,
  QUESTION_UID_MULTI_PART,
  QUESTION_UID_VIDEO,
  QUESTION_UID_AUDIO,
];

// TODO: remove key usage
// icon2: An alternative icon for the question type, to be used in the revamped UI
// localeLabel2: An alternative localeLabel for the question type, to be used in the revamped UI
export const QUESTION_TYPE_DETAILS = {
  [CONTENT_UID_TEXT_BOX]: {
    key: "65",
    localeLabel: "worksheet:text_or_content_box",
    icon: <DashboardOutlined size="xx-small" />,
    perm: CONTENT_TEXT_BOX_PERM,
    isSubQuestion: true,
    canAddToLibrary: false,
  },
  [QUESTION_UID_TEXT_RESPONSE_V3]: {
    key: "232",
    localeLabel: "common:text_response",
    icon: <TextOutlined size="xx-small" />,
    perm: "FeatureFlag:WorksheetsV2TextResponse",
    isSubQuestion: true,
    canAddToLibrary: true,
  },
  [QUESTION_UID_TRUE_FALSE_V2]: {
    key: "231",
    localeLabel: "common:true_or_false",
    icon: <AssessmentandEvaluationOutlined size="xx-small" />,
    icon2: <TickCrossOutlined size="xx-small" />,
    perm: "FeatureFlag:WorksheetsV2TrueOrFalse",
    isSubQuestion: true,
    canAddToLibrary: true,
  },
  [QUESTION_UID_MULTI_PART]: {
    key: "230",
    localeLabel: "worksheet:multipart_question",
    localeLabel2: "worksheet:multi_part_with_hyphen",
    icon: <ListNumberedOutlined size="xx-small" />,
    perm: "FeatureFlag:WorksheetsV2MultiPart",
    isSubQuestion: false,
    canAddToLibrary: true,
  },
  [QUESTION_UID_BLANKS]: {
    key: "233",
    localeLabel: "common:fill_in_the_blanks",
    icon: <QuestionMarkBlankOutlined size="xx-small" />,
    perm: "FeatureFlag:WorksheetsV2FillInTheBlanks",
    isSubQuestion: true,
    canAddToLibrary: true,
  },
  [QUESTION_UID_MULTI_CHOICE]: {
    key: "234",
    localeLabel: "worksheet:multiple_choice",
    icon: <ChecklistOutlined size="xx-small" />,
    perm: "FeatureFlag:WorksheetsV2MultipleChoice",
    isSubQuestion: true,
    canAddToLibrary: true,
  },
  [ADD_QUESTION_FROM_LIBRARY]: {
    key: ADD_QUESTION_FROM_LIBRARY,
    localeLabel: "worksheet:add_from_library",
    icon: <JournalOutlined size="xx-small" />,
    icon2: <JournalFilled size="xx-small" style={{ color: colors.pink300 }} />,
    icon3: <BooksTwoOutlined size="xx-small" />,
    isSubQuestion: true,
    localeLabel3: "toddleLibrary:import_from_toddle_library",
    illustration: ResourcesIllustration,
    isQuestionCreationMethod: true,
  },
  [QUESTION_UID_GRAPHING]: {
    key: "235",
    localeLabel: "worksheet:graphing_question",
    icon: <TeacherResourceOutlined size="xx-small" />,
    perm: "FeatureFlag:WorksheetsV2Graphing",
    localeLabel2: "worksheet:graphing",
    isSubQuestion: true,
    canAddToLibrary: true,
  },
  [QUESTION_UID_DRAWING]: {
    key: "236",
    localeLabel: "worksheet:drawing_question",
    localeLabel2: "worksheet:drawing",
    icon: <WorkbookOutlined size="xx-small" />,
    perm: "FeatureFlag:WorksheetsV2Drawing",
    isSubQuestion: true,
    canAddToLibrary: true,
  },
  [QUESTION_UID_DRAG_AND_DROP]: {
    key: "237",
    localeLabel: "worksheet:drag_and_drop_question",
    localeLabel2: "worksheet:drag_and_drop",
    icon: <MoveOutlined size="xx-small" />,
    perm: "FeatureFlag:WorksheetsV2Drag&Drop",
    isSubQuestion: true,
    canAddToLibrary: true,
  },
  [GENERATE_USING_AI]: {
    key: GENERATE_USING_AI,
    localeLabel: "worksheet:generate_using_ai",
    icon: <StarsTwoFilled variant={"link"} />,
    icon2: (
      <StarsTwoFilled variant={"link"} style={{ color: colors.blue400 }} />
    ),
    isSubQuestion: false,
    localeLabel3: "worksheet:create_with_toddle_ai",
    illustration: NoWorkbookTemplatesIllustration,
    isQuestionCreationMethod: true,
  },
  [EXTRACT_FROM_DOC]: {
    key: EXTRACT_FROM_DOC,
    localeLabel: "worksheet:extract_docs_forms",
    icon: <FolderFilled variant={"link"} />,
    icon2: <FolderFilled variant={"link"} style={{ color: colors.blue400 }} />,
    perm: "FeatureFlag:WorksheetAIMediaExtraction",
    isSubQuestion: false,
    illustration: DocumentAIIllustration,
    isQuestionCreationMethod: true,
  },
  [QUESTION_UID_FIND_HOTSPOT]: {
    key: "238",
    localeLabel: "worksheet:hotspot_question",
    localeLabel2: "worksheet:hotspot",
    icon: <GoalsOutlined size="xx-small" />,
    icon2: <PinOutlined size="xx-small" />,
    perm: "FeatureFlag:WorksheetsV2Hotspot",
    isSubQuestion: true,
    canAddToLibrary: true,
  },
  [QUESTION_UID_TABLE]: {
    key: "239",
    localeLabel: "worksheet:table_question",
    localeLabel2: "worksheet:table",
    icon: <TableOutlined size="xx-small" />,
    perm: "FeatureFlag:WorksheetsV2Table",
    isSubQuestion: true,
    canAddToLibrary: true,
  },
  [QUESTION_UID_MATCHING]: {
    key: "240",
    localeLabel: "worksheet:matching_question",
    localeLabel2: "worksheet:matching",
    icon: <ReplaceOutlined size="xx-small" />,
    perm: "FeatureFlag:WorksheetsMatchingQuestion",
    isSubQuestion: true,
    canAddToLibrary: true,
  },
  [QUESTION_UID_LABELLING]: {
    key: "241",
    localeLabel: "worksheet:labelling",
    icon: <TagOutlined size="xx-small" />,
    perm: "FeatureFlag:WorksheetsLabelFillQuestion",
    isSubQuestion: true,
    canAddToLibrary: true,
  },
  [QUESTION_UID_SEPARATOR]: {
    key: "243",
    localeLabel: "worksheet:separator",
    icon: <AddOutlined size="xx-small" />,
    perm: "FeatureFlag:WorksheetSinglePageFlow",
    isSubQuestion: false,
    canAddToLibrary: false,
  },
  [QUESTION_UID_AUDIO]: {
    key: "244",
    localeLabel: "common:audio_response",
    icon: <MicrophoneOutlined size="xx-small" />,
    perm: "FeatureFlag:WorksheetsAudioQuestion",
    isSubQuestion: true,
    canAddToLibrary: true,
  },
  [QUESTION_UID_VIDEO]: {
    key: "245",
    localeLabel: "worksheet:video_response",
    icon: <VideoOutlined size="xx-small" />,
    perm: "FeatureFlag:WorksheetsVideoQuestion",
    isSubQuestion: true,
    canAddToLibrary: true,
  },
};

export const DYNAMIC_FIELDS = [
  FIELD_UID_ASSESSMENT_TOOL,
  FIELD_UID_ADD_LEARNING_GOALS,
  FIELD_UID_ANSWER,
  FIELD_UID_TEACHER_NOTES,
];

export const DYNAMIC_FIELDS_V2 = [
  FIELD_UID_ANSWER,
  FIELD_UID_TEACHER_NOTES,
  FIELD_UID_ASSESSMENT_TOOL,
  FIELD_UID_ADD_LEARNING_GOALS,
];

export const DP_WORKSHEET = "dp_worksheet";
export const UBD_WORKSHEET = "ubd_worksheet";
export const MYP_WORKSHEET = "myp_worksheet";
export const PYP_WORKSHEET = "pyp_worksheet";

export const WORKSHEET_TEMPLATES = [
  DP_WORKSHEET,
  UBD_WORKSHEET,
  MYP_WORKSHEET,
  PYP_WORKSHEET,
];

/**
 * @description Generates a set of assessment tool options tailored to a specific curriculum type.
 * The function offers a default base structure of assessment options and, based on the provided
 * curriculum type (e.g., 'IB_PYP', 'IB_MYP', 'IB_DP', 'UbD').
 *
 * @param {string} curriculumType - The type of curriculum (e.g., 'IB_PYP', 'IB_MYP', 'IB_DP', 'UbD').
 * @returns {Array} An array of assessment tool options tailored to the given curriculum type.
 */

export const getAssessmentOptionsForCurriculum = curriculumType => {
  const DEFAULT_OPTIONS_FOR_ASSESSMENT_TOOL = [
    {
      isSubMenu: true,
      key: "RUBRIC",
      label: "Rubric",
      options: [
        {
          icon: "AddOutlined",
          key: "create_new",
          label: "Create new",
        },
        {
          icon: "AssessmentAddOutlined",
          key: "use_from_template",
          label: "Select a template",
        },
      ],
      value: "RUBRIC",
    },
    {
      isSubMenu: true,
      key: "SINGLE_POINT_RUBRIC",
      label: "Single Point Rubric",
      options: [
        {
          icon: "AddOutlined",
          key: "create_new",
          label: "Create new",
        },
        {
          icon: "AssessmentAddOutlined",
          key: "use_from_template",
          label: "Select a template",
        },
      ],
      value: "SINGLE_POINT_RUBRIC",
    },
    {
      isSubMenu: true,
      key: "CHECKLIST",
      label: "Checklist",
      options: [
        {
          icon: "AddOutlined",
          key: "create_new",
          label: "Create new",
        },
        {
          icon: "AssessmentAddOutlined",
          key: "use_from_template",
          label: "Select a template",
        },
      ],
      value: "CHECKLIST",
    },
  ];

  if (curriculumType === CURRICULUM_TYPE_MYP) {
    DEFAULT_OPTIONS_FOR_ASSESSMENT_TOOL.unshift(
      {
        key: MYP_OBJECTIVE_RUBRIC,
        label: "MYP criteria based rubric",
        value: MYP_OBJECTIVE_RUBRIC,
      },
      {
        key: MYP_INTERDISCIPLINARY_CRITERIA_RUBRIC,
        label: "Interdisciplinary criteria based rubric",
        value: MYP_INTERDISCIPLINARY_CRITERIA_RUBRIC,
      }
    );
  }

  if (curriculumType === CURRICULUM_TYPE_DP) {
    DEFAULT_OPTIONS_FOR_ASSESSMENT_TOOL.unshift(
      {
        key: "DP_ASSESSMENT_RUBRIC",
        label: "DP assessment criteria",
        value: "DP_ASSESSMENT_RUBRIC",
      },
      {
        isSubMenu: true,
        key: "IB_GRADE_SCALE",
        label: "IB grade scale",
        options: [
          {
            key: "ASSESSMENT_GRADE_BOUNDARY",
            label: "Grade manually",
            subText:
              "Manually assign IB grades to students while evaluating them",
          },
        ],
        value: "IB_GRADE_SCALE",
      }
    );
  }
  return DEFAULT_OPTIONS_FOR_ASSESSMENT_TOOL;
};

/**
 * @description the details of the fields that not created by default when
 * a question is created but are added dynamically post the creation of the question
 */
export const DYNAMIC_FIELD_DETAILS = ({ curriculumType = "IB_PYP" }) => ({
  [FIELD_UID_ASSESSMENT_TOOL]: {
    localeLabel: "classRoom:assessment_tools",
    tooltipLabel: "classRoom:evaluation_methods",
    icon: <AssessmentApplicableOutlined />,
    isDropdown: true,
    fieldConfig: {
      type: "MeasureAssessing",
      label: "common:le_assessmentTool_label",
      showOnlyOnModes: [MODE_TEACHER_CREATE],
      showOnlyOnActiveQuestion: true,
      config: {
        isAssessmentCreationRevamp: true,
        defaultOptions: getAssessmentOptionsForCurriculum(curriculumType),
        showDropdown: false,
      },
    },
  },
  [FIELD_UID_ADD_LEARNING_GOALS]: {
    localeLabel: "common:learning_goals",
    icon: <GoalsOutlined variant="subtle" />,
    hideForSubQuestion: true,
    isDropdown: true,
    fieldConfig: {
      type: "AddLearningGoals",
      label: "common:learning_goals",
      showOnlyOnModes: [MODE_TEACHER_CREATE],
      showOnlyOnActiveQuestion: false,
    },
  },
  [FIELD_UID_ANSWER]: {
    localeLabel: "academicSetup:answer_text",
    informationText: "worksheet:answer_field_subtext",
    icon: <TickCircleOpenOutlined variant="subtle" />,
    isDropdown: false,
    fieldConfig: {
      type: "RichText_Ported",
      viewType: "Accordion",
      config: {},
    },
  },
  [FIELD_UID_TEACHER_NOTES]: {
    localeLabel: "common:teacher_notes",
    informationText: "worksheet:teacher_notes_field_subtext",
    icon: <NoteOutlined variant="subtle" />,
    isDropdown: false,
    fieldConfig: {
      type: "RichText_Ported",
      viewType: "Accordion",
      config: {},
    },
  },
});
/** key to replace the answers with in order to put text inputs in its place on view/attempt modes */
export const BLANKS_ANSWER_REPLACEMENT = "&BLANKS&";
export const BLANK_SANITIZED_ANSWER_REPLACEMENT = "&amp;BLANKS&amp;";
export const BLANKS_ANSWER_REGEX = new RegExp(
  `(${BLANKS_ANSWER_REPLACEMENT}|${BLANK_SANITIZED_ANSWER_REPLACEMENT})`,
  "g"
);
/** string used to separate two answers in a answer block */
export const BLANKS_ANSWER_SEPARATOR = ";";
export const BLANKS_ANSWER_START_CHAR = "{";
export const BLANKS_ANSWER_END_CHAR = "}";

export const BLANKS_MIN_WIDTH = 120;
export const BLANKS_MAX_WIDTH = 720;

export const fillInTheBlanksModes = [
  "create",
  "preview",
  "edit",
  "view",
  "evaluate",
];

export const McqModes = ["create", "preview", "edit", "view", "evaluate"];
export const graphModes = ["create", "preview", "edit", "view", "evaluate"];

export const QUESTION_FIELD_ICON_MAPPING = {
  SettingsOutlined: <SettingsOutlined />,
};

export const COMMENT_FIELD_DETAILS = {
  localeLabel: "common:comments",
  icon: <CommentTextOutlined />,
  fieldConfig: {
    type: "Accordion",
    viewType: "Accordion",
    config: {
      showDetails: true,
    },
  },
};

export const FIELD_ERROR_MESSAGES = {
  [FIELD_UID_RICH_TEXT_EDITOR]: "worksheet:enter_question_text",
  [FIELD_UID_TITLE]: "worksheet:enter_question_text",
  [FIELD_UID_RADIO]: "worksheet:mcq_correct_answer_toast",
  [FIELD_UID_MCQ_CHOICES]: "worksheet:mcq_correct_answer_toast",
  [FIELD_UID_BLANKS]: "worksheet:blanks_correct_answer_toast",
  [FIELD_UID_SCORE]: "worksheet:enter_maximum_mark_for_question",
};

export const SCHOOL_LIBRARY = "school_library";
export const TODDLE_LIBRARY = "toddle_library";

export const LIBRARY_TYPE_OPTIONS = [
  {
    label: "common:toddle_library",
    value: TODDLE_LIBRARY,
  },
  {
    label: "worksheet:school_library",
    value: SCHOOL_LIBRARY,
  },
];

export const QUESTION_ORDER_OPTIONS = [
  {
    key: "CREATED_AT",
    label: "common:date_added",
  },
  {
    key: "QUESTION_POPULARITY",
    label: "common:popularity",
  },
];

export const GRAPH_TYPE_OPTIONS = [
  { label: "worksheet:classic", key: "classic" },
  { label: "worksheet:graphing", key: "graphing" },
  { label: "worksheet:geometry", key: "geometry" },
];

export const WORKSHEET_AI_QUESTION_OPTIONS = [
  {
    key: "Text response",
    value: "Text response",
    label: "common:text_response",
  },
  {
    key: "Fill in the blanks",
    value: "Fill in the blanks",
    label: "common:fill_in_the_blanks",
  },
  {
    key: "Multiple choice",
    value: "Multiple choice",
    label: "common:multiple_choice",
  },
  {
    key: "True or false",
    value: "True or false",
    label: "common:true_or_false",
  },
];
//ai gen cache id
export const NODE_ID = "nodeId";
export const QUESTION_ID = "questionId";
export const TITLE_ID = "titleId";
export const ANSWER_TEXT_ID = "answerTextId";
export const ANSWERS_TEXT_ID = "answersTextId";
export const RADIO_ID = "radioId";
export const MARKS_ID = "marksId";
export const LEARNING_GOAL_ID = "learningGoalId";
export const SETTINGS_ID = "settingsId";
export const CHOICES_ID = "choicesId";
export const CHOICE_1 = "choice1";
export const CHOICE_2 = "choice2";
export const CHOICE_3 = "choice3";
export const CHOICE_4 = "choice4";
export const BLANKS_ID = "blanksId";
export const BLANK_ANSWER_ID = "blankAnswerId";
export const AI_GEN_IDENTIFIER = "Ai_gen";
export const INLINE_TEXT_ID = "inlineTextId";
export const PARENT_ID = "parentId";

export const TEMPLATE_FIELDS_TO_REMOVE = [
  "dpElements",
  "pypElements",
  "resourcesStep",
  "teacherNotes",
];

export const fillInTheBlanksAnsRegex = /\[\s*\[([\s\S]+?)\]\s*\]/;

export const blankFormate = ["#BLANKS#", "#BLANK#", "#BLANK1#"];

// Safe Exam browser
export const SEB_DOWNLOAD_LINK_MAC =
  "https://cloud.toddleapp.com/assets/worksheet/seb/SafeExamBrowser-3.6.1.dmg";
export const SEB_DOWNLOAD_LINK_WINDOWS =
  "https://cloud.toddleapp.com/assets/worksheet/seb/SEB_3.10.1.864_SetupBundle.exe";

export const AI_SUPPORTED_QUESTION_TYPES = [
  QUESTION_UID_TRUE_FALSE_V2,
  QUESTION_UID_TEXT_RESPONSE_V3,
  QUESTION_UID_BLANKS,
  QUESTION_UID_MULTI_CHOICE,
];

export const AI_QUESTION_DEFAULT_SCORE = "1";

export const customTextStyle = {
  fontSize: "1.6rem",
  lineHeight: "2rem",
  fontWeight: "400",
  ...fontStyles.regular,
  color: colors.textDefault,
};

export const customTextStyleV2 = {
  fontSize: "16px",
  lineHeight: "24px",
  ...fontStyles.medium,
  color: "var(--text-primary)",
  margin: "0",
};

export const WS_AI_QUESTION_TAGS = {
  FIELD_QUESTION_INDICATOR: "qs",
  TYPE_OF_QUESTION_TAG: "toq",
  CHOICES_TAG: "chs",
  QUESTION_TEXT_TAG: "qtx",
  ANSWER_TEXT_TAG: "atx",
  CORRECT_ANSWER_TAG: "cna",
  SYLLABUS_CONTENT_DP: "sdp",
  LEARNER_PROFILE_DP: "ldp",
  SUBJECT_STANDARD_DP: "ssd",
  ATL_DP: "adp",
  ATLS_MYP: "amp",
  LEARNING_STANDARD_MYP: "lsm",
  CONCEPTS_MYP: "cmp",
  RELATED_CONCEPTS_MYP: "rcm",
  LP_MYP: "lpm",
  OBJECTIVES_MYP: "obm",
  INQUIRY_QUESTION: "iqq",
  INTERDISCIPLINARY_CRITERIA_MYP: "icm",
  LEARNING_STANDARD_UBD: "lsu",
  ATLS_UBD: "atu",
  QUESTION_MARK_TAG: "mark",
  WORKSHEET_INSTRUCTION_TAG: "wi",
};

const {
  FIELD_QUESTION_INDICATOR,
  TYPE_OF_QUESTION_TAG,
  CHOICES_TAG,
  QUESTION_TEXT_TAG,
  ANSWER_TEXT_TAG,
  CORRECT_ANSWER_TAG,
  SYLLABUS_CONTENT_DP,
  LEARNER_PROFILE_DP,
  SUBJECT_STANDARD_DP,
  ATL_DP,
  ATLS_MYP,
  LEARNING_STANDARD_MYP,
  CONCEPTS_MYP,
  RELATED_CONCEPTS_MYP,
  LP_MYP,
  OBJECTIVES_MYP,
  INQUIRY_QUESTION,
  INTERDISCIPLINARY_CRITERIA_MYP,
  LEARNING_STANDARD_UBD,
  ATLS_UBD,
  WORKSHEET_INSTRUCTION_TAG,
  QUESTION_MARK_TAG,
} = WS_AI_QUESTION_TAGS;

export const QUESTION_TAG_REGEX = new RegExp(
  `</?${FIELD_QUESTION_INDICATOR}>`,
  "g"
);

export const QUESTION_END_TAG = `</${FIELD_QUESTION_INDICATOR}>`;
export const QUESTION_START_TAG = `<${FIELD_QUESTION_INDICATOR}>`;

export const WS_INSTRUCTION_START_TAG = `<${WORKSHEET_INSTRUCTION_TAG}>`;
export const WS_INSTRUCTION_END_TAG = `</${WORKSHEET_INSTRUCTION_TAG}>`;

export const QUESTIONS_REGEX = new RegExp(
  `<${FIELD_QUESTION_INDICATOR}>([\\s\\S]*?)(</${FIELD_QUESTION_INDICATOR}>|$)`,
  "g"
);

export const WS_ASSISTANT_QUESTIONS_REGEX = new RegExp(
  `<${FIELD_QUESTION_INDICATOR}>([\\s\\S]*?)(?=<\\/${FIELD_QUESTION_INDICATOR}>|$)`,
  "g"
);
export const CHOICE_REGEX = new RegExp(
  `<${CHOICES_TAG}>([\\s\\S]*?)<\\/${CHOICES_TAG}>`,
  "g"
);
export const CHOICE_TAGS_REGEX = new RegExp(`</?${CHOICES_TAG}>`, "g");
export const CORRECT_ANSWER_REGEX = new RegExp(
  `<${CORRECT_ANSWER_TAG}>\\s*(\\d+)\\s*<\\/${CORRECT_ANSWER_TAG}>`,
  "g"
);
export const TYPE_OF_QUESTION_REGEX = new RegExp(
  `<${TYPE_OF_QUESTION_TAG}>[\\s\\S]*?<\\/${TYPE_OF_QUESTION_TAG}>`,
  "g"
);
export const FIELD_QUESTION_REGEX = new RegExp(
  `<\\/?${FIELD_QUESTION_INDICATOR}>`,
  "g"
);

export const QUESTION_TEXT_REGEX = new RegExp(`<${QUESTION_TEXT_TAG}>`, "gi");

export const QUESTION_TAG_LOCALES = {
  [ANSWER_TEXT_TAG]: "academicSetup:answer_text",
  [CORRECT_ANSWER_TAG]: "common:correct_ans",
  [CHOICES_TAG]: "worksheet:choices",
  [SYLLABUS_CONTENT_DP]: "common:syllabus_content_label",
  [SUBJECT_STANDARD_DP]: "common:subject_standards",
  [LEARNING_STANDARD_MYP]: "common:learning_standards",
  [CONCEPTS_MYP]: "common:concepts_label",
  [RELATED_CONCEPTS_MYP]: "common:related_concepts",
  [ATL_DP]: "common:atls_label",
  [ATLS_MYP]: "common:atls_label",
  [LP_MYP]: "common:lp_label",
  [OBJECTIVES_MYP]: "common:myp_objectives",
  [INQUIRY_QUESTION]: "common:inquiryQuestions_label",
  [INTERDISCIPLINARY_CRITERIA_MYP]: "common:interdisciplinary_criteria",
  [LEARNER_PROFILE_DP]: "common:learner_profile",
  [LEARNING_STANDARD_UBD]: "common:learning_standards",
  [ATLS_UBD]: "atls_label",
  [QUESTION_MARK_TAG]: "common:marks",
};

export const LEARNING_GOALS_UID_TAGS_MAPPING = {
  learnerProfileDP: LEARNER_PROFILE_DP,
  atlDP: ATL_DP,
  subjectStandardDP: SUBJECT_STANDARD_DP,
  syllabusContentDP: SYLLABUS_CONTENT_DP,
  atlsMYP: ATLS_MYP,
  learningStandardMYP: LEARNING_STANDARD_MYP,
  conceptsMYP: CONCEPTS_MYP,
  relatedConceptsMYP: RELATED_CONCEPTS_MYP,
  lpMYP: LP_MYP,
  inquiryQuestions: INQUIRY_QUESTION,
  objectivesMYP: OBJECTIVES_MYP,
  interdisciplinaryCriteriaMYP: INTERDISCIPLINARY_CRITERIA_MYP,
  learningStandardUBD: LEARNING_STANDARD_UBD,
  altUBD: ATLS_UBD,
};

// for adding this assessment tool in MYP, this learning goals fields needs to be created in questionFields
export const REQUIRED_FIELD_FOR_ASSESSMENT_TOOL = {
  MYP_OBJECTIVE_RUBRIC: "objectivesMYP",
  MYP_INTERDISCIPLINARY_CRITERIA_RUBRIC: "interdisciplinaryCriteriaMYP",
};

export const CREATE_DROP_DOWN_OPTIONS = [
  { key: "upload_device", label: "upload_device" },
  { key: "add_google_drive", label: "add_google_drive" },
  { key: "add_one_drive", label: "add_one_drive" },
];

export const WORKSHEET_THEATER_MODE_MIMETYPES = {
  // Images
  jpg: "image/jpeg",
  jpeg: "image/jpeg",
  png: "image/png",

  // Videos
  mp4: "video/mp4",
  mov: "video/quicktime",
  qt: "video/quicktime",
  webm: "video/webm",

  // Audio
  mp3: "audio/mp3",
  m4a: "audio/m4a",
  wav: "audio/wav",
  wave: "audio/wave",
  aac: "audio/aac",
  flac: "audio/flac",

  // Documents
  pdf: "application/pdf",
  doc: "application/msword",
  docx:
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  xls: "application/vnd.ms-excel",
  xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  ppt: "application/vnd.ms-powerpoint",
  pptx:
    "application/vnd.openxmlformats-officedocument.presentationml.presentation",
};

// worksheet prompts field types
export const WORKSHEET_PROMPT_FIELD_TYPE = {
  GENERATE_WORKSHEET_QUESTION: "GENERATE_WORKSHEET_QUESTION",
  DISPLAY_PROMPT_TYPE: "display",
};

export const EXTRACT_FROM_DOC_LOADER = {
  0: "common:processing",
  25: "worksheet:extracting_questions",
  50: "worksheet:mapping_learning_goals",
  75: "worksheet:finalising_output",
  100: "worksheet:preparing_display",
};

export const WORKSHEET_ELEMENT_IDS = {
  WORKSHEET_QUESTION_CONTENT_AREA_ID: "WORKSHEET_QUESTION_CONTENT_AREA_ID",
  WORKSHEET_ADD_QUESTION_DROPDOWN_ID: "WORKSHEET_ADD_QUESTION_DROPDOWN_ID",
  WORKSHEET_SIDEBAR_COLLAPSE_ID: "WORKSHEET_SIDEBAR_COLLAPSE_ID",
  WORKSHEET_QUESTION_ASSISTANT_ID: "WORKSHEET_QUESTION_ASSISTANT_ID",
  WORKSHEET_SINGLE_PAGE_CONTAINER: "WORKSHEET_SINGLE_PAGE_CONTAINER",
  WORKSHEET_ADD_QUESTION_IN_BETWEEN_ID: "WORKSHEET_ADD_QUESTION_IN_BETWEEN_ID",
  WORKSHEET_AI_ASSESSMENT_TOOLS_ID: "WORKSHEET_AI_ASSESSMENT_TOOLS_ID",
  WORKSHEET_STUDENT_SUBMISSION_CONTAINER_ID:
    "WORKSHEET_STUDENT_SUBMISSION_CONTAINER_ID",
};

export const MAX_SIZE_10_MB = 10485760;

export const SECTION_AND_NODE_KEY = "242";
export const DURATION_PICKER_OPTIONS = [
  { label: "1 min", key: "1" },
  { label: "2 min", key: "2" },
  { label: "5 mins", key: "5" },
  { label: "10 mins", key: "10" },
];

export const DEFAULT_MEDIA_SUBMISSION_METHOD = "record_or_upload";

export const ALLOWED_AUDIO_FILE_TYPES = [
  "audio/mpeg",
  "audio/x-m4a",
  "audio/mp3",
  "audio/wav",
  "audio/wave",
  "audio/vnd.wave",
  "audio/vnd.wav",
  "audio/x-wav",
  "audio/aac",
];

export const ALLOWED_VIDEO_FILE_TYPES = [
  "video/mp4",
  "video/mpeg",
  "video/avi",
  "video/webm",
  "video/quicktime",
  "video/wmv",
  "video/x-matroska",
  "video/webm;codecs=vp8,opus",
];

export const RTE_HEIGHT_QUESTION_RESPONSE_FIELD_TABLET = 71;
export const RTE_HEIGHT_QUESTION_RESPONSE_FIELD = 170;

export const DOC_EDITOR_HEIGHT_TABLET = 150;
export const DOC_EDITOR_HEIGHT = 216;

// Rich text view styles used across worksheet components
export const RICHTEXT_VIEW_STYLES = {
  richTextViewMode: {
    fontWeight: "400",
  },
  richTextViewModeV2: {
    color: "var(--text-primary)",
    lineHeight: "24px",
  },
  isStudentRevampStyle: {
    fontWeight: "500",
    lineHeight: "24px",
    fontSize: "16px",
  },
};

export const WORKSHEET_VIEW_STEPS = t => [
  {
    label: t("common:details"),
    value: "ASSESSMENT_DETAILS",
    heading: t("common:details"),
    subHeading: t("classRoom:classes_discussion_shared_with"),
  },
  {
    label: t("worksheet:questions"),
    value: "QUESTION_CREATION",
    heading: t("worksheet:questions"),
    subHeading: t("classRoom:classes_discussion_shared_with"),
  },
];

export const DOC_EDITOR_STYLES = {
  CONTAINER_STYLES: {
    width: "100%",
  },
  COMPACT_VARIANT_STYLES: {
    contentEditable: {
      padding: "12px 36px 12px 32px",
    },
    contentWrapper: {
      padding: 0,
    },
  },
  COMPACT_VARIANT_STYLES_VIEW: {
    editorContainer: {
      border: "none",
      borderRadius: "0",
      background: "unset",
    },
    contentBgProvider: {
      maxHeight: "unset",
      background: "unset",
    },
    contentWrapper: {
      padding: 0,
    },
    contentEditable: {
      padding: 0,
    },
    anchorElement: {
      background: "unset",
    },
  },
  MINI_EDITOR_CONTAINER_STYLES: {
    flexShrink: "unset",
    height: "100%",
    width: "100%",
  },
  MINI_EDITOR_MATCHING_STYLES: {
    contentEditableBgProvider: {
      border: "none",
      height: "100%",
    },
    contentEditableWrapper: {
      border: `1px solid ${colors.borderSubtle}`,
      borderRadius: "6px",
      padding: "8px",
    },
  },
  MINI_EDITOR_MATCHING_STYLES_VIEW: {
    contentEditableBgProvider: {
      border: "none",
      textAlign: "left",
      backgroundColor: "transparent",
    },
  },
  MINI_EDITOR_TABLE_STYLES: {
    contentEditableBgProvider: {
      border: "none",
      backgroundColor: "transparent",
    },
    contentEditableWrapper: {
      padding: "8px 16px",
      minHeight: "56px",
      display: "block",
    },
  },
  MINI_EDITOR_BLANKS_CONTAINER_STYLES: {
    display: "inline-block",
    verticalAlign: "middle",
    width: "auto",
    minWidth: "130px",
    maxWidth: "100%",
  },
  MINI_EDITOR_BLANKS_STYLES: {
    contentEditableBgProvider: {
      border: "none",
      textAlign: "center",
      backgroundColor: "transparent",
    },
    contentEditableWrapper: {
      height: "32px",
      borderRadius: "6px",
      border: "1px solid var(--border-secondary)",
      padding: "0 8px",
      display: "flex",
      alignItems: "center",
    },
    contentEditableDraggable: {
      width: "100%",
    },
  },
};

export const DOC_EDITOR_OVERRIDE_ELEMENTS = {
  img: {
    loading: "lazy",
    lazyStrictness: "high",
    decoding: "async",
  },
  iframe: {
    loading: "lazy",
    lazyStrictness: "high",
  },
  video: {
    loading: "lazy",
    lazyStrictness: "high",
    preload: "metadata",
    playsInline: true,
  },
  audio: {
    loading: "lazy",
    lazyStrictness: "high",
    preload: "metadata",
  },
};
